const READY_CHECK_TIMEOUT_MS = 11 * 1000; // 11 seconds
const SCRIPT_LOAD_TIMEOUT_MS = 10 * 1000; // 10 seconds
const READY_CHECK_INTERVAL_MS = 100; // 100 milliseconds

const DEVICE_MODE_DESTINATIONS_PLUGIN = 'DeviceModeDestinationsPlugin';

export {
  READY_CHECK_TIMEOUT_MS,
  DEVICE_MODE_DESTINATIONS_PLUGIN,
  SCRIPT_LOAD_TIMEOUT_MS,
  READY_CHECK_INTERVAL_MS,
};
